<adapt-dialog [maxWidth]="720">
    <h3 adapt-dialog-title>Edit agenda for meeting: {{ meeting.name }}</h3>
    <ng-container adapt-dialog-content>
        <adapt-edit-agenda [meeting]="meeting"
                           (agendaItemsChange)="agendaItems = $event"></adapt-edit-agenda>
    </ng-container>
    <div adapt-dialog-footer
         class="d-flex w-100">
        <button class="ms-auto"
                adaptButton="close"
                data-test="close-edit-agenda-dialog"
                (click)="cancel()"></button>
    </div>
</adapt-dialog>
